// React
import React from 'react'
// Components
import Button from '../Display/Button'
import Logo from '../Display/Logo'

export default class Welcome extends React.Component {

	componentDidMount() {
		window.scrollTo(0, 0)
	}

	render() {
		return (
			<div className='capps-container'>
				<Logo {...this.props} />
				<div className='capps-responsive'>
					<div className='capps-height-10' />
					<div className='capps-form'>
						The moon sign is often overlooked in astrology—and yet it often reveals more about you than your sun sign because it points to your inner nature. Generally speaking, the sun sign describes your “wants”, or how you project out into the world, whereas the moon sign describes your “needs”, or how you give to yourself.
						<div className='capps-height-10' />
						You can look up and read about your moon sign with this Moon Sign App for free. You can also create a free account to save your moon sign information and discover your relationship energy with other people based on your respective moon signs.
					</div>
					<div className='capps-height-10' />
					<Button
						action={() => {
							setTimeout(() => {
								window.localStorage.removeItem('MoonSignApp:welcome')
								if (this.props.state.nav.length > 1) {
									this.props.redux.nav.removePage()
								}
								else {
									this.props.redux.nav.setPage('login')
								}
							}, 20)
						}}
						text='Continue'
					/>
					<div className='capps-height-10' />
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/Components/Pages/Welcome.js